var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"nudge-left":"","bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":_vm.color},domProps:{"innerHTML":_vm._s(_vm.icon)}})],1)]}}])},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }